import { SET_SUBCONTRACTOR } from 'actions';

export function setSubcontractor(sourceType: string) {
  return { sourceType, type: SET_SUBCONTRACTOR };
}
